export default "__VITE_ASSET__D1cj_J9u__"